import { MouseEvent } from 'react';
import cn from 'classnames';
import { ReactComponent as Back } from '@packages/shared/assets/back.svg';
import styles from './ButtonBack.module.scss';

type ButtonBackProps = {
  secondary?: boolean;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
};

const ButtonBack = ({ secondary, onClick, className = '' }: ButtonBackProps) => {
  const buttonClasses = cn({
    [styles.secondary]: secondary,
    [styles.btn]: !secondary,
    [className]: !!className,
  });
  return (
    <button type="button" onClick={onClick} className={buttonClasses}>
      <Back className={styles.img} title="back" />
    </button>
  );
};

export default ButtonBack;
